/**
 * 策略模式
 * @param actions 每一种可能执行的操作
 */
export function exeStrategyActions(actions: Common.StrategyAction[]) {
    actions.some((item) => {
        const [flag, action] = item
        if (flag) {
            action()
        }
        return flag
    })
}
/**
 * 计算两个时间戳之间的月份和天数差
 * @param timestamps 时间戳数组，包含两个时间戳
 * @returns months - 月份差，days - 天数差
 */
export function calculateMonthDayDifference(timestamps: [number, number]) {
    // 验证输入
    if (!Array.isArray(timestamps)) {
        throw new Error("Input must be an array")
    }
    if (timestamps.length !== 2) {
        throw new Error("Array must contain exactly two timestamps")
    }
    // 排序时间戳（确保第一个是较早的时间）
    const sorted = [...timestamps].sort((a, b) => a - b)
    const start = new Date(sorted[0])
    const end = new Date(sorted[1])
    // 获取UTC时间组件
    const startYear = start.getUTCFullYear()
    const startMonth = start.getUTCMonth()
    const startDay = start.getUTCDate()
    const endYear = end.getUTCFullYear()
    const endMonth = end.getUTCMonth()
    // const endDay = end.getUTCDate()
    // 计算完整月份数
    let totalMonths = (endYear - startYear) * 12 + (endMonth - startMonth)
    // 创建临时日期（用于处理月末日期边界）
    let tempDate = new Date(
        Date.UTC(startYear, startMonth + totalMonths, startDay)
    )
    // 调整月份数（如果临时日期超过结束日期）
    if (tempDate > end) {
        totalMonths -= 1
        tempDate = new Date(
            Date.UTC(startYear, startMonth + totalMonths, startDay)
        )
    }
    // 计算剩余天数（基于UTC时间戳）
    const diffTime = end.getTime() - tempDate.getTime()
    // 说明：这里采用包含两端日期的计数方式（inclusive），
    // 比如 2025-11-10 到 2025-11-21 应视为 12 天而不是 11 天。
    const msPerDay = 1000 * 60 * 60 * 24
    const days = Math.floor(diffTime / msPerDay) + 1
    return { months: totalMonths, days }
}
